var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-clock",
    transform: "translate(1515 -28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_973",
    "data-name": "Rectangle 973",
    width: 37,
    height: 37,
    transform: "translate(-1515 28)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4728",
    "data-name": "Group 4728",
    transform: "translate(-1532.174 -105.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5882",
    "data-name": "Path 5882",
    d: "M18.264,6.715H16.841v7.921l5.142,2.444.611-1.285-4.33-2.058Z",
    transform: "translate(18.1 137.821)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5883",
    "data-name": "Path 5883",
    d: "M11.8,1.125A10.674,10.674,0,1,0,22.472,11.8,10.674,10.674,0,0,0,11.8,1.125Zm0,19.924A9.251,9.251,0,1,1,21.049,11.8,9.251,9.251,0,0,1,11.8,21.049Z",
    transform: "translate(23.875 139.875)",
    fill: "#c1c1c1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.d88a5d0029506d762116c0d120f024ad.svg";
export { ForwardRef as ReactComponent };